export enum GENRE_ACTION_TYPE {
  LIST = 'genre/list',
  CREATE = 'genre/create',
  UPDATE = 'genre/update',
  DELETE = 'genre/delete',
}
